import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_EARNED_ACCELERATOR_BONUS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EarnedAcceleratorBonusContent} from './EarnedAcceleratorBonusContent';
import reportPayload from './reportPayload';

export const EarnedAcceleratorBonusReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Earned Coach Accelerator Bonus')}
      description={tt(
        'description',
        'These Coaches earned their Coach Accelerator bonus. Time to celebrate & help them to their next milestone!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EarnedAcceleratorBonusContent}
    />
  );
};

export default withHOC(
  withTranslation('report.EarnedAcceleratorBonusReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_EARNED_ACCELERATOR_BONUS,
    popoverContentProps: {},
  }),
)(EarnedAcceleratorBonusReport);
